<template>
    <a-modal :title="`补充通话总结`" :width="600" :open="true" @cancel="cancel">
        <template #footer>
            <a-button @click="cancel">取消</a-button>
            <a-button type="primary" :loading="state.submitLoading" @click="onFormSubmit">保存理由及总结</a-button>
        </template>
        <a-skeleton :loading="state.loading" active :paragraph="{ rows: 10 }">
            <a-form ref="ruleForm" :model="formData" v-bind="formLayout">
                <a-form-item label="操作原因" name="reason" required>
                    <a-textarea v-model:value="formData.reason" :rows="3" placeholder="请输入"></a-textarea>
                </a-form-item>
                <a-form-item label="本次操作总结" name="remark" required>
                    <a-textarea v-model:value="formData.remark" :rows="4" placeholder="请输入"></a-textarea>
                </a-form-item>
            </a-form>
        </a-skeleton>
    </a-modal>
</template>

<script lang="ts" setup>
import { message, Modal } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import { reactive, onMounted, ref } from 'vue'
const formLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
    }
}
const ruleForm = ref()
const emit = defineEmits(['cancel', 'ok'])
const props = defineProps({
    detailData: {
        type: Object,
        default: () => { }
    }
})
interface IState {
    loading: boolean
    submitLoading: boolean
}
const state = reactive<IState>({
    loading: false,
    submitLoading: false,
})
interface IformData {
    reason: string
    remark: string
}
const formData = reactive<IformData>({
    reason: '风控电话',
    remark: '核实通过'
})
onMounted(() => {
})
// 提交
const onFormSubmit = () => {
    ruleForm.value
        .validate()
        .then(() => {
            state.loading = true
            let requeryParam = {
                url: '/admin/v1/customerLog/addtelreason',
                method: 'post',
                data: { id: props.detailData.id, ...formData }
            }
            baseService(requeryParam)
                .then((res: any) => {
                    state.loading = false
                    message.success(res.msg)
                    emit('ok')
                })
                .catch((res) => {
                    state.loading = false
                    if (res.msg) {
                        message.error(res.msg)
                    } else {
                        message.error('操作失败')
                    }
                })
        })
        .catch(() => { })
}
const cancel = () => {
    emit('cancel')
}
</script>

<style lang="less" scoped></style>
